import { render, staticRenderFns } from "./HODDashboard.vue?vue&type=template&id=408788e1"
import script from "./HODDashboard.vue?vue&type=script&lang=js"
export * from "./HODDashboard.vue?vue&type=script&lang=js"
import style0 from "./HODDashboard.vue?vue&type=style&index=0&id=408788e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports